module.exports = __webpack_public_path__ + "../resources/img/ic-add-module.45c1155c.svg";